import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import BackIcon from "../../../assets/communication/Back.svg";

export const AddCampaignHeader = (props) => {
  const navigate = useNavigate();
  return (
    <div className="campaigns_body">
        <div className="campaigns_addheader" >
          <div className="back-title-group" onClick={(e)=> props.backBtncallback(e)}>
            <img src={BackIcon} className="back-icon" />
            <span className="back-text">Back</span>
          </div>
        </div>
    </div>
  );
};